import { Component, Input, AfterContentInit } from '@angular/core';
import { DocumentDTO } from '../../api/plyca-dtos';
import { DocumentService } from '../document.service';

@Component({
    selector: 'rejectionPanel',
    templateUrl: 'rejectionPanel.template.html'
})
export class RejectionPanelComponent implements AfterContentInit {
    @Input() document: DocumentDTO;
    rejectionComment: string;

    constructor(protected documentService: DocumentService) {
    }

    ngAfterContentInit() {
        if (this.document) {
            this.rejectionComment = this.documentService.getRejectComment(this.document);
        }
    }
}
